import { combineReducers } from 'redux'

import products from './products.reducer'
import voucher from './voucher.reducer'
import establishment from './establishment.reducer'
import series from './series.reducer'
import users from './users.reducer'
import sales from './sales.reducer'
import orders from './orders.reducer'
import orderItems from './order_items.reducer'
import proformas from './proformas.reducer'
import proformaItems from './proforma_items.reducer'
import treasury from './treasury.reducer'
import treasuryMovementTypes from './treasury_movement_types.reducer'
import manageCash from './manage_cash.reducer'
import creditNote from './credit_note.reducer'
import manageCpe from './manage_cpe.reducer'
import electronicGuide from './electronic_guide.reducer'
import dashboard from './dashboard.reducer'
import accessControl from './access_control.reducer'
import menuControl from './menu_control.reducer'
import managementDriver from './management_driver.reducer'
import vehicles from './vehicles.reducer'
import vehicleRequirements from './vehicle_requirements.reducer'
import employees from './employees.reducer'
import vehicleServiceOrders from './vehicle_service_orders.reducer'
import vehiclesInventories from './vehicle_inventory.reducer'
import vehicleStations from './vehicle_stations.reducer'
import seriesProduct from './series_product.reducer'
import entriesAndOutputs from './entries_and_outputs.reducer'
import people from './people.reducer'
import cashMovements from './cash_movements.reducer'
import operatingExpenses from './operating_expenses.reducer'
import loansReducer from './loans.reducer'
import loansOpening from './loans_opening.reducer'
import loanOpeningMovements from './loan_opening_movements.reducer'
import stores from './stores.reducer'
import complaintsBook from './complaints_book.reducer'
import transfers from './transfers.reducer'
import transferItems from './transfer_items.reducer'
import inventories from './inventory.reducer'
import purchases from './purchases.reducer'
import purchaseItems from './purchase_items.reducer'
import customerCredits from './customer_credits.reducer'
import providerCredits from './provider_credits.reducer'
import providerCreditLetters from './provider_credit_letters.reducer'
import kardex from './kardex.reducer'
import profitReport from './profit_report.reducer'
import unitMeasures from './unit_measures.reducer'
import productUnitMeasures from './product_unit_measures.reducer'
import userServices from './user_services.reducer'
import productComplements from './product_complements.reducer'
import productSeries from './product_series.reducer'
import salesCPE from './sales_cpe.reducer'
import creditNotesCPE from './credit_notes_cpe.reducer'
import shippingGuidesCPE from './shipping_guides_cpe.reducer'
import userVouchers from './user_vouchers.reducer'
import paymentTypes from './payment_types.reducer'
import creditNotes from './credit_notes.reducer'
import productFiles from './product_files.reducer'
import productRequests from './product_requests.reducer'
import supplierOrders from './supplier_orders.reducer'
import supplierOrderItems from './supplier_order_items.reducer'
import productPrices from './product_prices.reducer'
import territorialDivision from './territorial_division.reducer'
import shippingGuides from './shipping_guides.reducer'
import outputs from './outputs.reducer'
import saleRetainers from './sale_retainers.reducer'
import seriesEntry from './series_entry.reducer'

const appReducers = combineReducers({
  accessControl,
  menuControl,
  products,
  voucher,
  establishment,
  series,
  users,
  sales,
  orders,
  orderItems,
  proformas,
  proformaItems,
  treasury,
  treasuryMovementTypes,
  manageCash,
  creditNote,
  manageCpe,
  electronicGuide,
  dashboard,
  managementDriver,
  employees,
  vehicles,
  vehicleRequirements,
  vehicleServiceOrders,
  vehiclesInventories,
  vehicleStations,
  seriesProduct,
  entriesAndOutputs,
  people,
  cashMovements,
  operatingExpenses,
  loansReducer,
  stores,
  complaintsBook,
  transfers,
  transferItems,
  loansOpening,
  loanOpeningMovements,
  inventories,
  purchases,
  purchaseItems,
  customerCredits,
  providerCredits,
  providerCreditLetters,
  kardex,
  profitReport,
  unitMeasures,
  productUnitMeasures,
  userServices,
  productComplements,
  productSeries,
  salesCPE,
  creditNotesCPE,
  shippingGuidesCPE,
  userVouchers,
  paymentTypes,
  creditNotes,
  productFiles,
  productRequests,
  supplierOrders,
  supplierOrderItems,
  productPrices,
  territorialDivision,
  shippingGuides,
  outputs,
  saleRetainers,
  seriesEntry,
})

export default appReducers